import { Injectable } from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {AuthService} from "../auth/auth.service";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor{

  constructor(private auth: AuthService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.auth.isLoggedIn()) {
          req = this.addJwtToken(req, this.auth.getJwtToken())
        }

        return next.handle(req);
    }

    private addJwtToken(req: HttpRequest<any>, jwt_token: string) {
      return req.clone({
          setHeaders: {'authorization' : `Bearer ${jwt_token}`}
      });
    }
}
